export enum UserRole {
    Admin=1,
    Dealer=2,
    Technician=3,
    Customer=4  
}
